import React from "react";

export default function Education(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16.834" height="13.774">
			<path
				d="M3.061 7.79v3.06l5.356 2.923 5.356-2.923V7.79l-5.356 2.923ZM8.417 0 0 4.591l8.417 4.591L15.3 5.425v5.288h1.53V4.591Z"
				fill="#32a8a4"
			/>
		</svg>
	);
}

export function EducationLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="78" height="64">
			<path
				d="M14.182 36.2v14.218L39 64l24.818-13.582V36.2L39 49.778ZM39 0 0 21.333l39 21.334 31.909-17.458v24.569H78V21.333Z"
				fill="#32a8a4"
			/>
		</svg>
	);
}
